class Header {

	constructor() {
		this.init();
	}

	init() {
    $(document).on('click', '.toggle-search', function(){
      $('#navgiation-search, #site-navigation, #content, #breadcrumbs').toggleClass('search-open');
      $('#navgiation-search #search').focus();
    });

		$(document).on('click', '.hide-visit', function(){
      $('#hide-visit-container').toggleClass('hide');
    });
	}
}

export default Header;
